import Loader from './AsyncComponentLoader.component'

export default Loader
